var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.needFormat(_vm.type) ? 'ComplexTree' : 'NormalTree',{tag:"Component",attrs:{"name":_vm.name,"value":_vm.value,"type":_vm.type,"line":_vm.line,"showIndex":_vm.showIndex,"needComma":_vm.needComma,"level":_vm.level,"lineType":_vm.lineType,"lastLineType":_vm.lastLineType,"lastLine":_vm.lastLine}})
}
var staticRenderFns = []

export { render, staticRenderFns }